import { Link } from 'react-router-dom';
import { comboBatteryCode, type InspectionJob } from '@cer-autofill/shared';

/**
 * On the solar half of a combo, battery details and photos live on the BTY
 * job. The hardware editor hides those sections whenever the job id starts
 * with PVD, so the banner is the way across.
 */
export function ComboBatteryBanner({
  job,
}: {
  job: Pick<InspectionJob, 'jobId' | 'relatedCaseId'>;
}) {
  const batteryJobId = comboBatteryCode(job);
  if (!batteryJobId) return null;
  return (
    <p className="banner banner--warning" role="status">
      This visit also has battery job{' '}
      <Link to={`/jobs/${encodeURIComponent(batteryJobId)}`}>{batteryJobId}</Link>. Battery details
      and photos go there.
    </p>
  );
}
